<ng-container *transloco="let t">
    <p class="bazis-contact()__name">
        {{ contact().last_name }}&nbsp; {{ contact().first_name }}&nbsp;
        {{ contact().middle_name }}
    </p>
    @if (contact().position) {
        <p class="bazis-contact()__position">{{ contact().position }}</p>
    }

    @if (contact().email) {
        <p class="bazis-contact()__mail">
            <a [href]="'mailto:' + contact().email">{{ contact().email }}</a>
        </p>
    }

    @if (contact().phone) {
        <p class="bazis-contact()__phone">
            <a>{{ contact().phone | phone }}</a>
            @if (contact().phone_additional) {
                , {{ t('title.phone_additional') }} {{ contact().phone_additional }}
            }
        </p>
    }
</ng-container>
